import type { MarkingPage, StoredMarking } from '#shared/utils/markings/schema'
import { markingPageSchema } from '#shared/utils/markings/schema'
import { safeParse } from 'valibot'

export async function loadAllMarkings(
  fetchPage: (cursor?: string | null) => Promise<MarkingPage>,
): Promise<StoredMarking[]> {
  const records: StoredMarking[] = []
  const seenCursors = new Set<string>()
  let cursor: string | null | undefined

  do {
    const parsed = safeParse(markingPageSchema, await fetchPage(cursor))

    if (!parsed.success) {
      throw new Error('Invalid markings response')
    }

    records.push(...parsed.output.markings)
    cursor = parsed.output.cursor

    if (cursor && seenCursors.has(cursor)) {
      throw new Error('Markings pagination did not advance')
    }

    if (cursor) {
      seenCursors.add(cursor)
    }
  } while (cursor)

  return records
}
